const CustomerScreenEvents = {
    // EPOS is sending an update for the 'state' of the customer screen. The state includes the current
    // company, branch, and user, and also the contents of the cart and what stage of the cart the customer
    // screen should be displaying.
    // The payload sent may be only a subset of the entire state.
    STATE_UPDATED: 'STATE_UPDATED',

    // EPOS has requested that the customer screen display a question to the customer.
    ASK_QUESTION: 'ASK_QUESTION',

    // EPOS has requested that the customer screen cancel asking a question.
    // This question may be currently displayed on the screen, or it might be in the queue to show.
    CANCEL_QUESTION: 'CANCEL_QUESTION',

    // EPOS has requested that the customer screen cancel asking all questions.
    CANCEL_QUESTIONS: 'CANCEL_QUESTIONS',

    // Customer screen confirms it has has received the question, but it is not yet shown.
    QUESTION_RECEIVED: 'QUESTION_RECEIVED',

    // Customer screen confirms it is currently displaying the question.
    QUESTION_DISPLAYED: 'QUESTION_DISPLAYED',

    // Customer screen is sending back the answer that the customer selected for a question.
    QUESTION_ANSWERED: 'QUESTION_ANSWERED',

    // EPOS is requesting that the customer screen displays a QR code to the customer.
    // The payload will be the data that should be contained in the QR code.
    SHOW_QR_CODE: 'SHOW_QR_CODE',

    // Customer screen confirms it is currently displaying the QR code.
    QR_CODE_DISPLAYED: 'QR_CODE_DISPLAYED',

    // EPOS has requested that the customer screen stop displaying a QR code.
    HIDE_QR_CODE: 'HIDE_QR_CODE',
};

module.exports = CustomerScreenEvents;
